import { t } from 'i18next';
import * as Yup from 'yup';

export const lessThanXCharsNotEndBacklash = (fieldName: string, numChars: number) =>
  Yup.object({
    [fieldName]: Yup.string()
      .trim()
      .nullable()
      .max(numChars, `validation.lessThan${numChars}Chars`)
      .test(fieldName, 'validation.notEndBackslash', (val) => {
        if (val) {
          return Boolean(val.match(/^.*(?:[^\\]|[\s\w/])$/));
        }

        return true;
      }),
  });

export const lessThanXCharsNotEndBacklashRequired = (fieldName: string, numChars: number) =>
  Yup.object({
    [fieldName]: Yup.string()
      .trim()
      .max(numChars, `validation.lessThan${numChars}Chars`)
      .required('validation.fieldRequired')
      .test(fieldName, 'validation.notEndBackslash', (val) => {
        if (val) {
          return Boolean(val.match(/^.*(?:[^\\]|[\s\w/])$/));
        }

        return true;
      }),
  });

export const requiredNumberBetweenXAndY = (
  fieldName: string,
  lowerBound: number,
  upperBound: number
) =>
  Yup.object({
    [fieldName]: Yup.number()
      .nullable()
      .required('validation.fieldRequired')
      .min(lowerBound, t('validation.betweenXAndY', { x: lowerBound, y: upperBound }))
      .max(upperBound, t('validation.betweenXAndY', { x: lowerBound, y: upperBound })),
  });

export const numberBetweenXAndY = (fieldName: string, lowerBound: number, upperBound: number) =>
  Yup.object({
    [fieldName]: Yup.number()
      .nullable()
      .min(lowerBound, t('validation.betweenXAndY', { x: lowerBound, y: upperBound }))
      .max(upperBound, t('validation.betweenXAndY', { x: lowerBound, y: upperBound })),
  });
